<div class="sidebar-panel" #getSidebar>
    <div id="scroll-area" [perfectScrollbar] class="navigation-hold" fxLayout="column">
        <div class="sidebar-hold">

            <!-- App Logo -->
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="center center" class="branding">
                <!-- <img src="assets/images/mpntr-logo.jpg" alt="" class="app-logo"> -->
                <div class="m-auto"
                    *ngIf="!(getSidebar.offsetWidth>100 && layoutConf.sidebarCompactToggle)||!layoutConf.sidebarCompactToggle"
                    style="color:white !important;line-height: normal !important; display: grid !important;">
                    <span class="m-auto"
                        style="font-size: 16px; font-weight: 600; margin:auto">{{'general.sideNavTitle.METAREGISTAR'|translate}}</span>
                </div>

                <span style="margin: auto" *ngIf="layoutConf.sidebarStyle !== 'compact'"></span>
                <div data-testid="btnSidebarSwitch" class="sidebar-compact-switch"
                    [ngClass]="{active: layoutConf.sidebarCompactToggle}" (click)="toggleCollapse()"
                    *ngIf="layoutConf.sidebarStyle !== 'compact'"><span></span></div>
            </div>

            <!-- Navigation -->
            <app-sidenav [items]="menuItems" [hasIconMenu]="hasIconTypeMenuItem" [iconMenuTitle]="iconTypeMenuTitle">
            </app-sidenav>

            <!--Verzija aplikacije-->
            <div class="m-auto"
                style="position: absolute; bottom: 0;color:white !important;line-height: normal !important; margin-top: 30px !important; margin-left:  15px !important;">
                <span class="m-auto" style="font-size: 10px; font-weight: 300; margin:auto">{{'general.VERSION'
                    | translate}} {{verzija}}</span>
            </div>
        </div>
    </div>
</div>